// lib
import { connect } from 'react-redux';
import get from 'lodash/get';

// component
import EcomPolicy from './NewEcomPolicy';

// redux
import {
  getCashOnDeliveryDetails,
  getDeliveryDetails,
  getReturnExchangeDetails,
  getProductId,
  getAllInStockSKUs,
  getDeliveryOrShippingText,
  isFetching,
} from 'shared/store/details/selectors';

// actions
import { setFetchEstimatedDeliveryDetails } from 'shared/store/details/actions';

import { getRemoteConfig } from 'shared/store/remoteConfigs/selectors';

const mapStateToProps = (state: any) => {
  return {
    cashOnDelivery: getCashOnDeliveryDetails(state),
    returnAndExchange: getReturnExchangeDetails(state),
    deliveryDetails: getDeliveryDetails(state),
    productId: getProductId(state),
    isFetching: isFetching(state),
    inStockSKUs: getAllInStockSKUs(state),
    deliveryOrShippingText: getDeliveryOrShippingText(state),
    isEddEnabled: get(getRemoteConfig(state, 'eddEnabled'), 'desktop', true),
  };
};

const mapDispatchToProps = { setFetchEstimatedDeliveryDetails };

export default connect(mapStateToProps, mapDispatchToProps)(EcomPolicy);
